<template>
    <div>
        <div v-for="item in items" :key="item.id" class="px-4 pt-0 mt-1 pb-4 mb-4 rounded-lg bg-white hover:bg-blue-200 border border-white hover:border-gray-200">
            <div class="w-full mb-1 text-lg flex mt-2">
                <div class="flex-1 flex-grow" v-text="item.reference+' - '+item.description"></div>
            </div>
            <div v-if="item.materials.length"
                 class="flex mt-2 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px">Material
                </div>
                <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px">UoM</div>
                <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Required
                </div>
                <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Requested</div>
                <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Ordered
                </div>
                <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Received</div>
                <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Still
                    Required
                </div>
            </div>
            <div
                class="flex mt-2 p-2 border rounded-lg border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold"
                v-else>
                No materials for this item
            </div>
            <resource-planning-report-material-item
                v-for="(material,index) in item.materials" :item="material"
                :key="index">
            </resource-planning-report-material-item>
        </div>
    </div>
</template>

<script>

import UiToggle from "../ui/UiToggle.vue";
import {resolveNumericText, toCurrency, uuid} from "../../utils";
import {ResourcePlanningReport} from "@models";
import ResourcePlanningReportMaterialItem from "./ResourcePlanningReportMaterialItem.vue";
import ResourcePlanningReportBudget from "./ResourcePlanningReportBudget.vue";
import {array} from "i/lib/util";

export default {
    components: {
        ResourcePlanningReportBudget,
        ResourcePlanningReportMaterialItem,
        UiToggle,
    },
    props: {
        items: array,
        split: Object,
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
    async mounted() {
    }
};
</script>
